import React, { FC, useEffect, useState } from 'react'
import LogoImg from '../../../images/logo.png'
import { Link, useLocation } from 'react-router-dom'
import { SideMenuProps } from './types'
import SideMenuItem from './side_menu_item'

const SideMenu: FC<SideMenuProps> = (props) => {
  const [isOpen, setIsOpen] = useState(() => {
    const saved = localStorage.getItem('sideMenuIsOpen')
    return saved !== null ? JSON.parse(saved) : true
  })

  const location = useLocation()

  useEffect(() => {
    localStorage.setItem('sideMenuIsOpen', JSON.stringify(isOpen))
  }, [isOpen])

  // ページ遷移時にxl未満の場合はメニューを閉じる
  useEffect(() => {
    // xl未満かどうかを判定（xlは1280px）
    if (window.innerWidth < 1280) {
      setIsOpen(false)
    }
  }, [location.pathname])

  // xl未満では画面外からメニューをスライドイン、xl以上では従来通り
  const menuTransform = isOpen ? 'translate-x-0' : '-translate-x-full xl:translate-x-0'

  return (
    <>
      {/* ハンバーガーメニューボタン（xl未満でのみ表示） */}
      <button
        onClick={() => setIsOpen(true)}
        className="fixed top-4 left-4 z-50 w-10 h-10 flex items-center justify-center bg-white rounded-md shadow-lg xl:hidden"
        aria-label="メニューを開く"
      >
        <span className="material-icons text-main-green">menu</span>
      </button>

      {/* スペーサー：xl以上でのみ表示 */}
      <div
        className={`hidden xl:block ${isOpen ? 'w-[250px]' : 'w-[38.5px]'}`}
      ></div>

      {/* オーバーレイ：xl未満でメニューが開いているときのみ表示 */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 xl:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* サイドメニュー本体 */}
      <div
        className={`fixed h-full bg-white transition-transform duration-300 flex flex-col z-50 ${menuTransform} ${
          isOpen ? 'w-[250px]' : 'xl:w-fit w-[250px]'
        }`}
      >
        <div className="flex justify-between items-center px-2 py-3 mb-4 relative flex-shrink-0">
          {isOpen && (
            <Link to="/dashboard" className="mx-auto">
              <img
                className="w-36 block cursor-pointer hover:opacity-80 transition-opacity"
                src={LogoImg}
                alt="logo"
              />
            </Link>
          )}
          {isOpen ? (
            <>
              {/* 閉じるボタン（xl以上でのみ表示） */}
              <div
                className="hidden xl:flex w-7 h-12 bg-white items-center justify-center cursor-pointer rounded-sm absolute left-[99%] top-1/2 -translate-y-1/2"
                onClick={() => setIsOpen(false)}
              >
                <span className="material-icons !text-base">
                  arrow_back_ios_new
                </span>
              </div>
              {/* ×ボタン（xl未満でのみ表示） */}
              <button
                className="xl:hidden absolute right-2 top-2 w-8 h-8 flex items-center justify-center"
                onClick={() => setIsOpen(false)}
                aria-label="メニューを閉じる"
              >
                <span className="material-icons text-main-green">close</span>
              </button>
            </>
          ) : (
            <div
              onClick={() => setIsOpen(true)}
              className="hidden xl:flex w-7 h-7 border border-white items-center justify-center cursor-pointer mt-5"
            >
              <span
                className={`material-icons !text-base transition-all rotate-180`}
              >
                arrow_back_ios_new
              </span>
            </div>
          )}
        </div>
        <div className="flex-1 overflow-y-auto">
          {props.items.map((item, index) => {
            return (
              <SideMenuItem
                sideMenuIsOpen={isOpen}
                icon={item.icon}
                label={item.label}
                items={item.children}
                path={item.path}
                key={`side_menu_item_parent_${index}`}
              />
            )
          })}
        </div>
      </div>
    </>
  )
}

export default SideMenu
